module.exports = __webpack_public_path__ + "assets/img/skip-icon.2e6f137b.svg";